export default "__VITE_ASSET__BQGxrix1__"